import React, { useState, createContext } from "react";

export const AppContext = createContext();

function setTokenWithExpiry(key, value, ttlMs) {
  const now = new Date();

  const item = {
    value: value,
    expiry: now.getTime() + ttlMs,
  };

  localStorage.setItem(key, JSON.stringify(item));
}

function getTokenWithExpiry(key) {
  const itemStr = localStorage.getItem(key);
  if (!itemStr) {
    return null;
  }

  const item = JSON.parse(itemStr);
  const now = new Date();

  if (now.getTime() > item.expiry) {
    // หมดอายุแล้ว
    localStorage.removeItem(key);
    return null;
  }

  return item.value;
}

const ContextProvider = ({ children }) => {
  const [isEnter, setIsEnter] = useState(false);
  const [roomSelected, setRoomSelected] = useState({});
  const [currentHotel, setCurrentHotel] = useState({});
  const [bookStartDate, setBookStartDate] = useState(null);
  const [bookEndDate, setBookEndDate] = useState(null);
  const [bookingData, setBookingData] = useState([]);

  // handle mouse enter
  const handleMouseEnter = () => {
    setIsEnter(true);
  };
  // handle leave
  const handleMouseLeave = () => {
    setIsEnter(false);
  };

  const handleSetRoomSelected = (room) => {
    setRoomSelected(room);
  };

  const handleSetBookingCartData = (data) => {
    localStorage.setItem('booking_cart_data', JSON.stringify(data));
  };

  const getBookingCartData = () => {
    const data = localStorage.getItem('booking_cart_data');
    return data ? JSON.parse(data) : {};
  };

  const bookingCartValue = getBookingCartData();

  const handleSetCurrentHotel = (hotel) => {
    localStorage.setItem('current_hotel', JSON.stringify(hotel));
    setCurrentHotel(hotel);
    const _bookingData = getBookingCartData();

    const cartHotelId = _bookingData?.cart_items && _bookingData?.cart_items.length > 0 ? _bookingData?.cart_items[0]?.hotel_id : null;
    if (cartHotelId && cartHotelId !== hotel.id) {
      handleSetBookingCartData({});
    }
  };

  const getCurrentHotel = () => {
    const hotel = localStorage.getItem('current_hotel');
    return hotel ? JSON.parse(hotel) : {};
  };

  const handleSetBookStartDate = (s) => {
    setBookStartDate(s);
  };

  const handleSetBookEndDate = (e) => {
    setBookEndDate(e);
  };

  const handleSetBookingData = (book) => {
    setBookingData(book)
  };

  const setDummyToken = (_token) => {
    localStorage.setItem('booking_overview_token_dummy', _token);
  };
  const getDummyToken = (_token) => {
    return localStorage.getItem('booking_overview_token_dummy');
  };

  const setDummyCleanerToken = (_token) => {
    localStorage.setItem('cleaner_overview_token_dummy', _token);
  };
  const getDummyCleanerToken = (_token) => {
    return localStorage.getItem('cleaner_overview_token_dummy');
  };

  const setAgentCodekey = (_data) => {
    setTokenWithExpiry('sale_agent_key', _data, 1000 * 60 * 60 * 24); // 24 hours
  }

  const getAgentCodekey = () => {
    return getTokenWithExpiry('sale_agent_key');
  }

  const clearAgentCodekey = () => {
    localStorage.removeItem('sale_agent_key');
  }

  const values = {
    isEnter,
    handleMouseEnter,
    handleMouseLeave,
    roomSelected,
    handleSetRoomSelected,
    currentHotel,
    handleSetCurrentHotel,
    bookStartDate,
    handleSetBookStartDate,
    bookEndDate,
    handleSetBookEndDate,
    bookingData,
    handleSetBookingData,
    setDummyToken,
    getDummyToken,
    setDummyCleanerToken,
    getDummyCleanerToken,
    setAgentCodekey,
    getAgentCodekey,
    clearAgentCodekey,
    getCurrentHotel,
    bookingCartValue,
    getBookingCartData,
    handleSetBookingCartData,
  };
  return <AppContext.Provider value={values}>{children}</AppContext.Provider>;
};

export default ContextProvider;
